﻿import React from 'react';

// lib
import { motion, AnimatePresence } from "framer-motion";

// utils
import IconHelper from '@bazooka_se/lf-icons';
import RawHtml from '../../../../../UI/RawHtml';

const PossessionsTableContentMobile = ({
    description,
    title,
    index,
    isExpanded,
    setIsExpanded
}) => {

    const isOpen = index === isExpanded;

    return (    
        <div className="possessions__table__body">
            <motion.div
                className="possessions__table__body__row"
                onClick={() => setIsExpanded(isOpen ? false : index)}>

                <p className="possessions__table__body__heading">{title}
                    <button
                        dangerouslySetInnerHTML={{ __html: IconHelper('chev-down').outerHTML }}
                        className="possessions__table__body__heading__icon">
                    </button>
                </p>

            <AnimatePresence
                initial={false}>
            {isOpen && (
                    <motion.div
                        className="possessions__table__body__foldout"
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.4 }}>

                        <RawHtml>{description}</RawHtml>  
                        
                    </motion.div>
                )}
                </AnimatePresence>

            </motion.div>
        </div>
     )
};

export default PossessionsTableContentMobile;

